module.exports = __webpack_public_path__ + "static/media/Lion-walk.29d08b1c.gif";